<div class="grid-row " (click)="reminderClick()" [ngClass]="{'bottom':isLast}"> 
    <div class="list-item flex-2 warp-ellipsis xxx">
        <p class="ellipsis-p">{{reminder?.subject}}</p>
    </div>
    <div class="tooltip-abs" *ngIf="reminder?.subject">
        <p>{{reminder?.subject}}</p>
    </div>
    <div class="list-item flex-1">{{reminder?.createDate | queDate }}</div>
    <div class="list-item flex-1">{{reminder?.startDate | queDate  }}</div>
    <div class="list-item flex-1">{{reminder?.hour??10}}:00</div>
    <div class="list-item flex-1" translate [translateParams]="{ frequency: frequency$ | async}">grid.frequencyName
    </div>
    <div class="list-item flex-1">{{reminder?.endDate | queDate  }} </div>
    <!-- not in amdocs -->
    <!-- <div *ngIf="reminder?.isApproval; else noApproval" class="list-item flex-1" translate>
        reminder.isApprovalYes
    </div>
    <ng-template #noApproval>
        <div class="list-item flex-1" translate> reminder.isApprovalNo</div>
    </ng-template> -->
    <!-- <div class="flex-1">{{reminder?.user}} </div> -->
    <div class="list-item flex-2">
        <que-distribution-recipients [recipients]="reminder?.recipients" [title]="'remindersUsers'"></que-distribution-recipients>
    </div>
    <div class="list-item flex-2 content">
        <div class="text-overflow">{{reminder?.content}}</div>
    </div>
    <div class="list-item flex-half last">
        <div #trigger (click)="openMenu($event)">
            <img src="/assets/images/grid/menuPoint.svg">
        </div>
        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayHasBackdrop]="true"
            [cdkConnectedOverlayOpen]="true" cdkConnectedOverlayBackdropClass="backdrop-selection"
            (backdropClick)="isMenuOpen=false" [cdkConnectedOverlayOpen]="isMenuOpen"
            [cdkConnectedOverlayPositions]="positonArea">
            <div class="overlay-warp">
                <div class="item" (click)="edit()">
                    <img src="/assets/images/grid/menu/edit.svg">
                    <p translate>grid.menu.edit</p>
                </div>
                <div class="hr"></div>
                <div class="item" (click)="delete()">
                    <img src="/assets/images/grid/menu/delete-red.svg">
                    <p class="red" translate>grid.menu.delete</p>
                </div>
                <!-- <div class="item" (click)="send()">
                    <img src="/assets/images/grid/menu/send.svg">
                    <p translate>grid.menu.send</p>
                </div> -->
            </div>
        </ng-template>
        <!-- <div (click)="navToData()">סיכום</div> -->
    </div>
</div>